module.exports = __webpack_public_path__ + "static/media/mobile.0e7d033c.svg";